<template>
  <div class="modal-body attendees-step">
    <div class="registration-errors" v-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div>

    <p
      v-if="conference.id === 5245 || conference.id === 5246 || conference.id === 5247"
      style="margin-top: 15px; margin-bottom: 15px;"
    >
      <strong>CPI is intended as a SCCAP Member Only Benefit.</strong>
      If you are not already a member, please join here:
      <a class="text-primary" href="https://sccap53.org/membership/join-sccap-renew-membership/" target="_blank" style="text-decoration: underline;">Join SCCAP</a>
      <br />Professional Memberships are $40. Student/Postdoc/Post Bac memberships are free!
    </p>

    <!-- Single Form -->
    <div v-if="attendeeForm" v-html="attendeeForm" class="registration-form" ref="attendeeForm" id="attendeeForm"></div>

    <!-- Multiple Form -->
    <validation-observer
      v-if="attendees?.length > 1"
      v-slot="{ invalid, valid, errors, handleSubmit, ...rest }"
      ref="attendeesForm"
      id="attendeesForm"
    >
      <div class="customer-info-form">
        <form @submit.prevent="handleSubmit(submitMultipleForm)">
          <div v-if="settings.checkoutNote" class="multiple-registration-description" v-html="settings.checkoutNote">
          </div>

          <div v-for="(item, index) in attendees" :key="`attendee-${index}`">
            <h5>Ticket {{index+1}} ({{item.ticket_name}})</h5>

            <!-- first_name -->
            <validation-provider :vid="`attendees.${index}.first_name`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.first_name`" class="control-label text-input">First Name <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.first_name`"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees.${index}.first_name`"
                  v-model="item.first_name"
                  maxlength="50"
                  required
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <!-- last_name -->
            <validation-provider :vid="`attendees.${index}.last_name`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.last_name`" class="control-label text-input">Last Name <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.last_name`"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees[${index}].last_name`"
                  v-model="item.last_name"
                  maxlength="50"
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <!-- email -->
            <validation-provider :vid="`attendees.${index}.email`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.email`" class="control-label text-input">Email <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.email`"
                  type="email"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees.${index}.email`"
                  v-model="item.email"
                  @blur="updateRegistrantWildApricotDiscount(item)"
                  maxlength="250"
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <!-- email_confirmation -->
            <validation-provider :vid="`attendees.${index}.email_confirmation`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.email_confirmation`" class="control-label text-input">Email Confirmation <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.email_confirmation`"
                  type="email"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees.${index}.email_confirmation`"
                  v-model="item.email_confirmation"
                  maxlength="250"
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <div
              class="addon-wrapper"
              v-for="(addon, addonIndex) in item.addons"
              :key="`attendees.${index}..addons.${addonIndex}`"
            >
              <validation-provider
                class="addon-status-wrapper"
                :vid="`attendees.${index}.addons.${addonIndex}.selected`"
                v-slot="{errors}"
              >
                <event-checkbox
                  :class="{'is-invalid': errors && errors[0]}"
                  :label="addon.title"
                  v-model="addon.selected"
                  @input="updateAddonStatus(addon, item.ticket_id)"
                ></event-checkbox>
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </validation-provider>

              <validation-provider
                v-show="!addon.has_sessions"
                :vid="`attendees.${index}.addons.${addonIndex}.quantity`"
                v-slot="{errors}"
              >
                <select
                  :id="`attendees.${index}.addons.${addonIndex}.quantity`"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  v-model="addon.selected_quantity"
                  :disabled="!addon.selected"
                  @change="updateAddonQuantities(addon, item.ticket_id)"
                >
                  <option value="0">0</option>
                  <option
                    v-for="(option, optionIndex) in addon.available_quantity"
                    :key="`ticket-${item.ticket_id}-${item.index}-addons-${addon.id}-option-${optionIndex}`"
                    :value="option"
                  >{{ option }}</option>
                </select>
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </validation-provider>
            </div>

            <br />
          </div>
        </form>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import formValidation from '../../plugins/formvalidation/dist/es6/core/Core'
import Trigger from '../../plugins/formvalidation/dist/es6/plugins/Trigger'
import Bootstrap from '../../plugins/formvalidation/dist/es6/plugins/Bootstrap'
import { scrollToNotValidField } from '../../helpers/scrollToNotValidField'
import { scrollToTop } from '../../helpers/scrollToTop'

export default {
  mounted() {
    if (document.getElementById('attendeeForm') && this.attendeeForm) {
      this.modifyAgreeCheckbox();
      this.hideParagraphAndHeaderLabels();
      this.initValidation();
      if (this.wildApricotEnabled) {
        this.initUpdateRegistrantWildApricotDiscount();
      }
    } else {
      if (this.attendees?.length) {
        this.attendees.forEach(attendee => {
          attendee.addons.forEach(addon => {
            if (addon.selected) {
              this.updateAddonQuantities(addon, attendee.ticket_id);
            }
          });
        });
      }
    }
  },
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "settings",
      "slug",
      "tickets",
      "attendeeForm",
      "attendeeValidation",
      "attendees",
      "errorMessage",
      "selectedSessionAddons",
      "selectedItemAddons",
      "wildApricotEnabled"
    ])
  },
  data() {
    return {
      formValidation: null
    }
  },
  methods: {
    ...mapActions('basketStore', ['fetchBasket', 'fetchAttendees', 'updateAttendees', 'updateWildApricotAttendeeDiscount']),

    updateRegistrantWildApricotDiscount(attendee) {
      if (this.wildApricotEnabled) {
        const requestData = {
          data: {
            id: attendee.id || null,
            email: attendee.email
          },
          success: () => {},
          error: (err) => {
            if (err?.flash) {
              this.errorMessage = err.flash;
            }
            if (err?.errors) {
              scrollToNotValidField(err.errors, '.modal-body.attendees-step');
            }
          }
        };

        this.updateWildApricotAttendeeDiscount(requestData);
      }
    },

    initUpdateRegistrantWildApricotDiscount() {
      const attendees = this.attendees;
      const updateWildApricotAttendeeDiscount = this.updateWildApricotAttendeeDiscount;
      let blurTimeout;
      let emailInput = document.querySelector('#attendeeForm input[name="email"]');

      emailInput.addEventListener('blur', () => {
        handleBlur();
      });

      function handleBlur() {
        if (blurTimeout) {
          clearTimeout(blurTimeout);
        }

        blurTimeout = setTimeout(() => {
          autoUpdateRegistrantDiscount();
        }, 100);
      }

      function autoUpdateRegistrantDiscount() {
        const emailInput = document.querySelector('#attendeeForm input[name="email"]');

        const requestData = {
          data: {
            id: attendees?.length ? attendees[0].id : null,
            email: emailInput.value
          },
          success: () => {},
          error: (err) => {
            if (err?.flash) {
              this.errorMessage = err.flash;
            }
            if (err?.errors) {
              scrollToNotValidField(err.errors, '.modal-body.attendees-step');
            }
          }
        };

        updateWildApricotAttendeeDiscount(requestData);
      }
    },

    updateAddonStatus(currentAddon, currentTicketId) {
      if (currentAddon.has_sessions) {
        let selectedCurrentAddonsQuantity = 0;
        const currentAddonId = currentAddon.id;

        this.attendees.forEach(attendee => {
          attendee.addons.forEach(addon => {
            //&& attendee.ticket_id === currentTicketId
            if (addon.id === currentAddonId && addon.selected) {
              selectedCurrentAddonsQuantity += 1;
            }
          });
        });
        this.$store.commit('basketStore/updateSelectedSessionAddons', selectedCurrentAddonsQuantity);
      }

      if (!currentAddon.has_sessions) {
        if (!currentAddon.selected) {
          currentAddon.selected_quantity = 0;
        }

        this.updateAddonQuantities(currentAddon, currentTicketId);
      }
    },

    updateAddonQuantities(currentAddon, currentTicketId) {
      let selectedCurrentAddonsQuantity = 0;
      let selectedTotalAddonsQuantity = 0;
      const currentAddonId = currentAddon.id;

      this.attendees.forEach(attendee => {
        attendee.addons.forEach(addon => {
          //addon.id === currentAddonId
          if (addon.selected) {
            selectedTotalAddonsQuantity += +addon.selected_quantity;
          }
          if (addon.id === currentAddonId && attendee.ticket_id === currentTicketId) {
            selectedCurrentAddonsQuantity += +addon.selected_quantity;
          }
        });
      });

      this.$store.commit('basketStore/updateSelectedItemAddons', selectedTotalAddonsQuantity);

      this.attendees.forEach(attendee => {
        attendee.addons.forEach(addon => {
          if (addon.id === currentAddonId && attendee.ticket_id === currentTicketId) {
            const availableQuantity = +addon.quantity - +selectedCurrentAddonsQuantity;
            addon.available_quantity = +addon.selected_quantity + +availableQuantity;
          }
        });
      });
    },

    modifyAgreeCheckbox() {
      const privacyLink = `/${this.slug}/policies`;

      $('label[for=\'agree[]\']').hide();
      $('label[for=\'agree\']').hide();
      $('label[for=\'receive_updates\']').hide();

      const agreeLabel = `I agree with the <a href="${privacyLink}" target="_blank">terms and conditions</a> of this site`;
      $('label[for=\'agree_agree\']').html(agreeLabel);
    },

    hideParagraphAndHeaderLabels() {
      const h1 = $('.registration-form h1.form-control-static');
      const h2 = $('.registration-form h2.form-control-static');
      const h3 = $('.registration-form h3.form-control-static');
      const h4 = $('.registration-form h4.form-control-static');
      const h5 = $('.registration-form h5.form-control-static');
      const h6 = $('.registration-form h6.form-control-static');
      const p = $('.registration-form p.form-control-static');
      const address = $('.registration-form address.form-control-static');
      const blockquote = $('.registration-form blockquote.form-control-static');
      const canvas = $('.registration-form canvas.form-control-static');
      const output = $('.registration-form output.form-control-static');

      if (h1.prev()) {
        h1.prev().hide();
      }
      if (h2.prev()) {
        h2.prev().hide();
      }
      if (h3.prev()) {
        h3.prev().hide();
      }
      if (h4.prev()) {
        h4.prev().hide();
      }
      if (h5.prev()) {
        h5.prev().hide();
      }
      if (h6.prev()) {
        h6.prev().hide();
      }

      if (p.prev()) {
        p.prev().hide();
      }
      if (address.prev()) {
        address.prev().hide();
      }
      if (blockquote.prev()) {
        blockquote.prev().hide();
      }
      if (canvas.prev()) {
        canvas.prev().hide();
      }
      if (output.prev()) {
        output.prev().hide();
      }
    },

    initValidation() {
      this.formValidation = formValidation(document.getElementById('attendeeForm'), {
        fields: {},
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      })

      for (const [key, value] of Object.entries(this.attendeeValidation)) {
        if (value.required) {
          this.formValidation.addField(`${key}`, {
            validators: {
              notEmpty: { message: `${value.label} is required` }
            }
          })
        }
      }
    },

    validateForm: async function() {
      return this.formValidation.validate().then(status => {
        return (this.validationStatus = status === 'Valid')
      })
    },

    resetForm() {
      // this.formValidation.resetForm()
    },

    submitForm: async function() {
      if (this.attendees?.length > 1) {
        this.$refs.attendeesForm.handleSubmit(this.submitMultipleForm);
      } else {
        // if (!(await this.validateForm())) {
        //   return;
        // }

        await this.submitSingleForm();
      }
    },

    submitSingleForm() {
      return new Promise(resolve => {
        let data = {}
        let form = document.querySelector('#attendeeForm form');

        if (form && form.elements && form.elements.length) {
          Array.from(form.elements).forEach(item => {
            if (item.type === 'radio') {
              if (item.checked) {
                data[item.name] = item.value
              }
            } else if (item.type === 'checkbox') {
              if (typeof data[item.name] === 'undefined') {
                data[item.name] = []
              }
              if (item.checked) {
                data[item.name].push(item.value)
              }
            } else {
              data[item.name] = item.value
            }
          })
        }

        const requestData = {
          attendees: [
            {
              ...data,
              id: this.attendees[0].id,
              ticket_id: this.attendees[0].ticket_id
            }
          ],
          success: () => {
            this.resetForm();
            this.$store.dispatch('basketStore/changeStep', { type: "forward" });
          },
          error: (err) => {
            if (err?.flash) {
              this.errorMessage = err.flash;
            }
            if (err?.errors) {
              // scrollToTop('.modal-body');
              scrollToNotValidField(err.errors, '.modal-body.attendees-step', true);
            }
          }
        };

        this.updateAttendees(requestData);
      })
    },

    submitMultipleForm: async function () {
      const data = {
        attendees: this.attendees,
        success: () => {
          this.$nextTick(() => {
            // this.$refs.attendeesForm.reset();
          });

          // go to next step
          this.$store.dispatch('basketStore/changeStep', { type: "forward" });
        },
        error: (err) => {
          if (err.errors) {
            this.$refs.attendeesForm.setErrors(err.errors);
            scrollToNotValidField(err.errors, '.modal-body.attendees-step');
          }
        }
      };

      this.$refs.attendeesForm.validate().then(success => {
        if (!success) {
          return
        }

        this.updateAttendees(data);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group .control-label {
  font-weight: 400;
}

.addon-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}

.addon-status-wrapper {
  margin-top: 10px;
}

::v-deep .app-checkbox div {
  font-weight: 400;
}

::v-deep .fv-help-block {
  font-family: sans-serif;
  font-weight: 700;
  color: #dc3545 !important;
  font-size: 16px;
}
</style>
